import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Description of an unversioned URL path in the Ab Initio Help library, used for things like the Agentic Data Service
 * help page.
 */
export class AbHelpUnversionedPath {
  constructor(path, label, icon) {
    _defineProperty(this, "_path", void 0);
    _defineProperty(this, "_label", void 0);
    _defineProperty(this, "_icon", void 0);
    this._path = path;
    this._label = label;
    this._icon = icon;
  }

  /**
   * The unversioned URL path rooted under $AB_HELP_URL/p/
   */
  get path() {
    return this._path;
  }

  /**
   * The label to show on help menus, buttons, etc
   */
  get label() {
    return this._label;
  }

  /**
   * The icon to display on help menus, buttons, etc. Default: <code>absdk:help</code>
   */
  get icon() {
    return this._icon ?? "absdk:help";
  }
}
//# sourceMappingURL=AbHelpUnversionedPath.js.map
